<template>
  <div class="qCardWrapper">
    <div :class="['itemBox', 'clear', content.view == 100 ? 'noMargin' : '']">
      <div class="content">
        <!--                <Question :text="content.tips" v-if="content.right"/>-->

        <div class="textBoxW" v-if="!content.right">
          <View0
            v-if="content.view === 0"
            :list="content.list"
            :tips="content.tips"
          ></View0>
          <View9
            v-if="content.view == 1"
            :list="content.list"
            :tips="content.tips"
            :buttonType="content.buttonType"
            @on-action="onBtnAction"
          />
          <View4
            v-if="content.view === 2"
            :list="content.list"
            :tips="content.tips"
          />
          <View5
            v-if="content.view === 4"
            :list="content.list"
            :tips="content.tips"
            @on-router="onNavigate"
          />
          <View11
            v-if="content.view === 5"
            :list="content.list"
            :tips="content.tips"
            @on-ask="onRequest"
          />
          <View7
            v-if="content.view === 6"
            :list="content.list"
            :tips="content.tips"
            @on-ask="onRequest"
          />
          <View8
            v-if="content.view === 7"
            :list="content.list"
            :tips="content.tips"
            @on-show="onShowNews"
          />
          <View12
            v-if="content.view == 8"
            :list="content.list"
            :tips="content.tips"
            @on-more="onMoreComment"
          />
          <View10
            v-if="content.view == 9"
            :list="content.list"
            :tips="content.tips"
            @on-action="onBtnAction"
            buttonType="hasBg"
          />
          <View6
            v-if="content.view == 10"
            :list="content.list"
            :tips="content.tips"
            @on-router="onNavigate"
          />
          <View2
            v-if="content.view == 11"
            :list="content.list"
            :tips="content.tips"
          />
          <!--                        <View3  v-if="content.view===12" :tips="content.tips"/>-->
          <View9
            v-if="content.view == 12"
            :list="content.list"
            :tips="content.tips"
            buttonType="noBg"
            @on-action="onBtnAction"
          />
          <View13
            v-if="content.view === 13"
            :tips="content.tips"
            :list="content.list"
          />
          <View14
            v-if="content.view == 14"
            :list="content.list"
            :tips="content.tips"
            :other="content"
            @on-process="onMultiProgress"
          />
          <View15
            v-if="content.view == 15"
            :list="content.list"
            :tips="content.tips"
            @on-show="onShowNews"
          />
          <View9
            v-if="content.view == 16"
            :list="content.list"
            :tips="content.tips"
            @on-action="onBtnAction"
            buttonType="noBg"
          />
          <View16
            v-if="content.view == 17"
            :list="content.list"
            :tips="content.tips"
            @on-ask="onTourDetails"
          />
          <View17
            v-if="content.view == 18"
            :list="content.list"
            :tips="content.tips"
          />
          <View18
            v-if="content.view == 19"
            :list="content.list"
            :tips="content.tips"
          />
          <View10
            v-if="content.view == 20"
            :list="content.list"
            :tips="content.tips"
            @on-action="onBtnAction"
            buttonType="hasBg"
          />
          <View23
            v-if="content.view === 21"
            :list="content.list"
            :tips="content.tips"
            type="activity"
            @on-action="onBtnAction"
          />
          <View23
            v-if="content.view === 22"
            :list="content.list"
            :tips="content.tips"
            type="QRcode"
          />
          <View23
            v-if="content.view === 23"
            :list="content.list"
            :tips="content.tips"
            type="carLimit"
          />
          <View23
            v-if="content.view === 24"
            :list="content.list"
            :tips="content.tips"
            type="stock"
          />

          <View24
            v-if="content.view === 25"
            :list="content.list"
            :tips="content.tips"
            type="activity"
            @on-show="onShowNews"
            @on-share="onBtnAction"
          />
          <View24
            v-if="content.view === 26"
            :list="content.list"
            :tips="content.tips"
            type="movie"
            @on-show="onShowNews"
          />

          <View19
            v-if="content.view == 28"
            :list="content.list"
            :tips="content.tips"
          />
          <View20
            v-if="content.view === 29"
            :list="content.list"
            :tips="content.tips"
            @on-show="onShowNews"
          />
          <View21
            v-if="content.view === 30"
            :list="content.list"
            :tips="content.tips"
            @on-show="onShowNews"
          />
          <View22
            v-if="content.view === 31"
            :list="content.list"
            :tips="content.tips"
          />

          <!--                        同时识别到FAQ和场景-->
          <View25
            v-if="content.view === 32"
            :list="content.list"
            :tips="content.tips"
            @on-ask="onRequest"
          />
          <!-- 每日诗歌  -->
          <View26
            v-if="content.view == 40"
            :list="content.list"
            @on-action="onBtnAction"
          ></View26>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  View1,
  View2,
  View3,
  View6,
  Question,
  View0,
  View8,
  View7,
  View4,
  View5,
  View11,
  View12,
  View9,
  View10,
  View14,
  View15,
  View13,
  View16,
  View17,
  View18,
  View19,
  View20,
  View21,
  View22,
  View23,
  View24,
  View25,
  View26,
} from "./View/index";
import COVERAPP from "@/utils/COVERAPP";
import { defPreImage, popConfirm, writeText } from "@/utils/utils";
import { mapState, mapActions, mapMutations } from "vuex";
import html2canvas from "html2canvas";
export default {
  name: "QCard",
  components: {
    View1,
    View2,
    View3,
    View6,
    Question,
    View0,
    View8,
    View7,
    View5,
    View11,
    View4,
    View12,
    View9,
    View10,
    View14,
    View15,
    View13,
    View16,
    View17,
    View18,
    View19,
    View20,
    View21,
    View22,
    View23,
    View24,
    View25,
    View26,
  },
  props: {
    content: {
      type: Object,
      default: {},
    },
  },
  computed: {
    ...mapState(["chatLoading", "readNewsId", "device", "isApp", "shareData","AutoplayIng"]),
    ...mapState("audio", ["xPlayer", "audioCurrentIndex", "audioList"]),
  },
  data() {
    return {
      shareImg: null,
      canvasW: 1240,
      canvasH: 1852,
    };
  },
  mounted() {},
  methods: {
    ...mapMutations([
      "contactDisData",
      "setHomeData",
      "setToastList",
      "setLinkSrc",
      "setGlobalDuration",
      "setChatLoading",
      "setLinkSrc",
      "setClearTimer",
      "setReadNewsId",
      "setOpenChat",
      "setInputShow",
      "setTagsList",
      "setToastContent",
      "setToastShow",
      "setAudioBarShow",
       "setShowPicTop",
      "setShowShareData ",
      "SetFeedbackDirection",
      "SetFeedbackType",
      "setOpenChatID",
    ]),
    ...mapMutations("audio", [
      "setAudioList",
      "setAudioCurrentIndex",
      "setAudioCurrentTime",
      "setDuration",
      "setXPlayer",
    ]),
    ...mapActions([
      "fetchRelate",
      "fetchHome",
      "fetchHomeNoData",
      "queryComment",
      "discussNewsOther",
      "getHotTopic",
      "getHotTopicDesc",
      "getHotTopicNews",
      "getHotNews",
      "getSceneCommon",
      "queryMultiProgress",
      "getSceneMultiProcess",
      "getTourData",
      "getWantToInfo",
      "getTourInfo",
      "getTourCommon",
      "getBillShare",
      "setMaskDataAsync",
      "asyncAudioAndPlay",
      "queryAudioList",
      "queryXimalayaList",
      "queryAudioBtn",
      "queryAudioScene",
      "getActivityScene",
      "shareActivity",
      "getQRCode",
       "exitFeedbackAsync",
      "feedbackSublistAsync",
      "feedbackDataAsync",
    ]),
    /*type:0（预设） 1（H5） 2（多流程） 3（测评）*/
    onNavigate(link, id, isCurrent, type, title, except, exceptValue) {
      let that = this;
      if (except === 1) {
        this.fetchHomeNoData({ payload: { question: exceptValue } }).then(
          (res) => {
            that.onTypeHandle(link, id, isCurrent, type, title);
          }
        );
      } else {
        this.onTypeHandle(link, id, isCurrent, type, title);
      }
      this.setClearTimer(true);
    },

    onTypeHandle(link, id, isCurrent, type, title) {
      if (isCurrent) {
        this.setLinkSrc(link);
        this.$router.push({
          path: "/blank",
        });
      } else {
        switch (type) {
          case 0:
            {
              // window.location.href = link;
              this.fetchHome({ payload: { question: title } }).then((res) => {
                if (res.length) {
                  this.setChatLoading(false);
                }
                setTimeout(() => {
                  this.service.pageScrollTo();
                }, 600);
                //cio.track(7, "click", 'send_msg',{msg: value});
              });
            }
            break;
          case 1:
            {
              window.location.href = link;
            }
            break;
          case 2:
            {
              this.onMultiProgress("", "", "", id);
            }
            break;
          case 3:
            {
              this.onMultiProgress("", "", "", id);
            }
            break;
          default:
            {
              //todo
            }
            break;
        }
      }
    },

    onMultiProgress(name, optionId, value, sceneId, nodeId, sessionId) {
      let that = this;
      this.setChatLoading(true);
      this.setGlobalDuration(0);
      this.contactDisData([{ content: { right: true, tips: name } }]);
      this.queryMultiProgress({
        payload: {
          question: value,
          nodeId,
          sceneId,
          sessionId,
          optionId,
        },
      }).then((res) => {
        if (res.length) {
          that.setChatLoading(false);
        }
        setTimeout(() => {
          that.service.pageScrollTo();
        }, 100);
      });
    },

    onRequest(name, value) {
      let that = this;
      this.setChatLoading(true);

      this.setGlobalDuration(0);
      that.contactDisData([{ content: { right: true, tips: name } }]);
      that.fetchHome({ payload: { question: value } }).then((res) => {
        if (res.length) {
          that.setChatLoading(false);
        }
        setTimeout(() => {
          that.service.pageScrollTo();
        }, 600);
        cio.track(7, "click", "send_msg", { msg: value });
      });
    },

    onMoreComment() {
      this.queryComment({ payload: { newsId: this.readNewsId } });
    },

    onTourDetails(name, id) {
      let that = this;
      this.setChatLoading(true);
      this.setGlobalDuration(0);
      this.contactDisData([
        { content: { right: true, tips: `小封小封，我想去${name}` } },
      ]);
      this.getTourInfo({ payload: { id } }).then((res) => {
        if (res.length) {
          that.setChatLoading(false);
        }
        setTimeout(() => {
          that.service.pageScrollTo();
        }, 100);
      });
    },

    onBtnAction(type, id, tips, value, sessionId) {
      let that = this;
      this.setChatLoading(true);
      this.setClearTimer(true);

      switch (type) {
        case 0:
          {
            //聊新闻
            // this.contactDisData([{content: {right: true, tips: value}}]);
            this.contactDisData([{ content: { view: 100, tips: value } }]);
            this.setInputShow(true);
            this.setOpenChat(true);
            this.setOpenChatID(0);
            this.setChatLoading(false);
            that.$nextTick(() => {
              that.service.onInputBlur();
            }, 1000);
          }
          break;
        case 1:
          {
            //返回全网新闻 不想看了 不感兴趣
            this.setInputShow(true);
            this.contactDisData([{ content: { right: true, tips } }]);
            this.getHotNews().then((res) => {
              this.setReadNewsId("");
              if (res.length) {
                that.setChatLoading(false);
              }
              setTimeout(() => {
                that.service.pageScrollTo();
              }, 300);
            });
          }
          break;
        case 2:
          {
            //返回其他新闻
            this.contactDisData([{ content: { right: true, tips } }]);
            this.discussNewsOther({ payload: { id: id } }).then((res) => {
              this.setReadNewsId("");
              if (res.length) {
                that.setChatLoading(false);
              }
              setTimeout(() => {
                that.service.pageScrollTo();
              }, 300);
            });
          }
          break;
        case 3:
          {
            //继续查看当前新闻的其他评论
            that.contactDisData([{ content: { right: true, tips } }]);
            this.queryComment({ payload: { newsId: this.readNewsId } }).then(
              (res) => {
                if (res.length) {
                  that.setChatLoading(false);
                }
                setTimeout(() => {
                  that.service.pageScrollTo();
                }, 300);
              }
            );
          }
          break;
        case 4:
          {
            //热点新闻  了解
            that.contactDisData([{ content: { right: true, tips } }]);
            this.getHotTopicNews({ payload: { id: id } }).then((res) => {
              if (res.length) {
                that.setChatLoading(false);
              }
              setTimeout(() => {
                that.service.pageScrollTo();
              }, 300);
            });
          }
          break;
        case 5:
          {
            //热点新闻  不了解
            that.contactDisData([{ content: { right: true, tips } }]);
            this.getHotTopicDesc({ payload: { id: id } }).then((res) => {
              if (res.length) {
                that.setChatLoading(false);
              }
              setTimeout(() => {
                that.service.pageScrollTo();
              }, 300);
            });
          }
          break;
        case 6:
          {
            // 不感兴趣
            that.contactDisData([{ content: { right: true, tips } }]);
            that.getSceneCommon({ payload: {} }).then((res) => {
              if (res.length) {
                that.setChatLoading(false);
              }
              setTimeout(() => {
                that.service.pageScrollTo();
              }, 300);
            });
          }
          break;
        case 7:
          {
            //好的，我看看 //好的，我听听
            // setTimeout(()=> {
            that.contactDisData([{ content: { right: true, tips } }]);
            that
              .fetchHome({ payload: { question: value, hasClearTimer: true } })
              .then((res) => {
                if (res.length) {
                  that.setChatLoading(false);
                }
                setTimeout(() => {
                  that.service.pageScrollTo();
                }, 300);
              });
            // }, 1000)
          }
          break;
        case 8:
          {
            //流程对话 再玩一次
            that.onMultiProgress(tips, "", "", id);
          }
          break;
        case 9:
          {
            that.contactDisData([{ content: { right: true, tips } }]);
            that.getSceneMultiProcess({ payload: {} }).then((res) => {
              if (res.length) {
                that.setChatLoading(false);
              }
              setTimeout(() => {
                that.service.pageScrollTo();
              }, 300);
            });
          }
          break;
        /*旅游推荐 不感兴趣*/
        case 10:
          {
            that.contactDisData([{ content: { right: true, tips } }]);
            that.getTourCommon().then((res) => {
              if (res.length) {
                that.setChatLoading(false);
              }
              setTimeout(() => {
                that.service.pageScrollTo();
              }, 300);
            });
          }
          break;
        /*旅游推荐 */
        case 11:
          {
            that.contactDisData([{ content: { right: true, tips } }]);
            that.getTourData({ payload: {} }).then((res) => {
              if (res.length) {
                that.setChatLoading(false);
              }
              setTimeout(() => {
                that.service.pageScrollTo();
              }, 300);
            });
          }
          break;
        /*旅游推荐 换一批*/
        case 12:
          {
            that.contactDisData([{ content: { right: true, tips } }]);
            that.getTourData({ payload: {} }).then((res) => {
              if (res.length) {
                that.setChatLoading(false);
              }
              setTimeout(() => {
                that.service.pageScrollTo();
              }, 300);
            });
          }
          break;
        /*旅游  我想去这里玩*/
        case 13:
          {
            that.contactDisData([{ content: { right: true, tips } }]);
            that.getWantToInfo({ payload: { id } }).then((res) => {
              if (res.length) {
                that.setChatLoading(false);
              }
              setTimeout(() => {
                that.service.pageScrollTo();
              }, 300);
            });
          }
          break;
        //移动 推荐 知道
        case 14:
          {
            that.setChatLoading(false);
            window.location.href =
              "https://m.thecover.cn/subject.html?id=4244&channel_type=30";
          }
          break;
        //移动 推荐 不知道  //旅游的接口  //新闻换一批
        case 15:
          {
            that.contactDisData([{ content: { right: true, tips } }]);
            that
              .fetchHome({
                payload: { question: value, noInput: value === "换一批" },
              })
              .then((res) => {
                if (res.length) {
                  that.setChatLoading(false);
                }
                setTimeout(() => {
                  that.service.pageScrollTo();
                }, 100);
              });
          }
          break;
        /*旅游  看看其他景点 radioType:16*/
        case 16:
          {
            that.contactDisData([{ content: { right: true, tips } }]);
            that.getTourData({ payload: {} }).then((res) => {
              if (res.length) {
                that.setChatLoading(false);
              }
              setTimeout(() => {
                that.service.pageScrollTo();
              }, 300);
            });
          }
          break;
        //喜马拉雅边听边玩其他的
        case 19:
          {
            that.contactDisData([{ content: { right: true, tips } }]);
            that.setAudioBarShow("ximalaya");
            that.asyncAudioAndPlay().then((res) => {
              if (res.length) {
                if (!this.xPlayer.getDuration()) {
                  this.xPlayer.playByIndex(this.audioCurrentIndex);
                } else {
                  // console.log("无论何时都走这里？？？？？？？",this.AutoplayIng)
                  if(this.AutoplayIng){
                  this.xPlayer.pause()
                  }else{
                  this.xPlayer.play();
                  }
                  
                }
                that.setChatLoading(false);
              }
            });
          }
          break;

        //每日听单边听边玩其他的
        case 20:
          {
            that.contactDisData([{ content: { right: true, tips } }]);
            that.setAudioBarShow("audio");
            that.asyncAudioAndPlay().then((res) => {
              if (res.length) {
                that.setChatLoading(false);
              }
            });
          }
          break;

        //看看其他栏目
        case 21:
          {
            that.contactDisData([{ content: { right: true, tips } }]);
            that.queryAudioBtn({ payload: { id } }).then((res) => {
              if (res.length) {
                that.setChatLoading(false);
              }
              setTimeout(() => {
                that.service.pageScrollTo();
              }, 600);
            });
          }
          break;
        // 再看看原创精品 封面
        case 23:
          {
            that.contactDisData([{ content: { right: true, tips } }]);
            that.fetchHome({ payload: { question: value } }).then((res) => {
              if (res.length) {
                that.setChatLoading(false);
              }
              setTimeout(() => {
                that.service.pageScrollTo();
              }, 600);
            });
          }
          break;
        // 听听本地频道
        case 24:
          {
            that.contactDisData([{ content: { right: true, tips } }]);
            that.fetchHome({ payload: { question: value } }).then((res) => {
              if (res.length) {
                that.setChatLoading(false);
              }
              setTimeout(() => {
                that.service.pageScrollTo();
              }, 600);
            });
          }
          break;
        // 啥也不想听了
        case 25:
          {
            that.contactDisData([{ content: { right: true, tips } }]);
            that.fetchHome({ payload: { question: value } }).then((res) => {
              if (res.length) {
                that.setChatLoading(false);
              }
              setTimeout(() => {
                that.service.pageScrollTo();
              }, 600);
            });
          }
          break;
        // 重新再看看 喜马拉雅
        case 26:
          {
            that.contactDisData([{ content: { right: true, tips } }]);
            that.queryAudioBtn({ payload: { id } }).then((res) => {
              if (res.length) {
                that.setChatLoading(false);
              }
              setTimeout(() => {
                that.service.pageScrollTo();
              }, 600);
            });
          }
          break;
        //生活频道不感兴趣
        case 27:
          {
            that.contactDisData([{ content: { right: true, tips } }]);
            that.queryAudioScene().then((res) => {
              if (res.length) {
                that.setChatLoading(false);
              }
              setTimeout(() => {
                that.service.pageScrollTo();
              }, 600);
            });
          }
          break;
        //残忍拒绝领票资格
        case 28:
          {
            that.contactDisData([{ content: { right: true, tips } }]);
            that.getActivityScene().then((res) => {
              if (res.length) {
                that.setChatLoading(false);
              }
              setTimeout(() => {
                that.service.pageScrollTo();
              }, 300);
            });
          }
          break;
        //立即分享
        case 29:
          {
            this.setChatLoading(false);
            if (this.isApp) {
              that.drawImg();
              setTimeout(() => {
                let longpress = that.device === "android" ? false : true;
                that.getQRCode({ payload: { id, longpress } }).then((res) => {
                  if (res.length) {
                    that.setChatLoading(false);
                  }
                  setTimeout(() => {
                    that.service.pageScrollTo();
                  }, 300);
                });
              }, 2000);
            } else if (this.device === "ios") {
              popConfirm(
                "请前往下载APP",
                () => {
                  window.open("https://apps.apple.com/cn/app/id1028293650");
                },
                () => {}
              );
            } else {
              popConfirm(
                "请前往下载APP",
                () => {
                  window.open(
                    "https://a.app.qq.com/o/simple.jsp?pkgname=cn.thecover.www.covermedia"
                  );
                },
                () => {}
              );
            }
          }
          break;
        //活动场景中的不感兴趣
        case 30:
          {
            that.contactDisData([{ content: { right: true, tips } }]);
            that.getActivityScene().then((res) => {
              if (res.length) {
                that.setChatLoading(false);
              }
              setTimeout(() => {
                that.service.pageScrollTo();
              }, 300);
            });
          }
          break;
        case 31:
          {
            that.contactDisData([{ content: { right: true, tips } }]);
            that.shareActivity({ payload: { id } }).then((res) => {
              if (res.length) {
                that.setChatLoading(false);
              }
              setTimeout(() => {
                that.service.pageScrollTo();
              }, 300);
            });
          }
          break;
        // 诗歌分享
        case 39:
          {
            that.setChatLoading(false);
            that.html2canvaDrawImg(600);
          }
          break;
        // 功能反馈有子目录
        case 41:
          {
            that.setChatLoading(false);
           
            this.SetFeedbackDirection(value);
            this.feedbackSublistAsync({ payload: { parentId: id } }).then(
              (res) => {
                if (res.length) {
                  this.setChatLoading(false);
                }
                setTimeout(() => {
                  this.service.pageScrollTo();
                }, 600);
              }
            );
          }
          break;

        case 42:
          {
            // 功能反馈没有子目录
            // 请求子目录
            this.setChatLoading(false);
          
            if (tips === "小封机器人") {
              this.SetFeedbackDirection(tips);
              this.SetFeedbackType("小封");
            } else {
              this.SetFeedbackType(tips);
            }

            this.contactDisData([{ content: { right: true, tips } }]);
            this.contactDisData([{ content: { view: 100, tips: value } }]);
            this.setInputShow(true);
            this.setOpenChat(true);
            this.setOpenChatID(1);
            this.setChatLoading(false);
            this.$nextTick(() => {
              that.service.onInputBlur();
            }, 1000);
          }
          break;
        //  功能反馈退出
        case 43:
          {
            that.setChatLoading(false);
            //返回全网新闻 不想看了 不感兴趣
            this.contactDisData([{ content: { right: true, tips } }]);
            this.exitFeedbackAsync();
          }
          break;
        default:
          break;
      }
    },

    onShowNews(id, info, toastType, closeColor) {
      this.setReadNewsId(id);
      this.setClearTimer(true);
      // this.setChatLoading(true);
      switch (toastType) {
        case 9:
          {
            this.queryAudioList({
              payload: { id: this.readNewsId, page: 1, pageSize: 10 },
            }).then((res) => {
              let columns = res[1].content.list;
              this.setToastContent({
                toastType,
                list: {
                  name: "",
                  content: Object.assign(info, { columns: columns }),
                },
                closeColor,
              });
              // this.setChatLoading(false);
              this.setToastShow(true);
            });
          }
          break;
        case 10:
          {
            this.queryXimalayaList({
              payload: { id: this.readNewsId, page: 1, pageSize: 10 },
            }).then((res) => {
              let columns = res[1].content.list;
              this.setToastContent({
                toastType,
                list: {
                  name: "",
                  content: Object.assign(info, { columns: columns }),
                },
                closeColor,
              });
              // this.setChatLoading(false);
              this.setToastShow(true);
            });
          }
          break;
        default:
          {
            this.setToastContent({
              toastType,
              list: { name: "", content: info },
              closeColor,
            });
            this.setChatLoading(false);
            this.setToastShow(true);
          }
          break;
      }
    },

    //分享图片
    shareImageApp(imageUrl) {
      if (this.isApp) {
        let image = imageUrl.split(";base64,")[1];
        let shareImgData = JSON.parse(JSON.stringify(this.shareData));
        shareImgData.image = image;
        COVERAPP.Method.shareImage(shareImgData);
      }
    },

    shareHbImg(c, ctx, bg, newsImg) {
      let _this = this;
      Promise.all([defPreImage(bg), defPreImage(newsImg)]).then((imgs) => {
        const leftMar = 180;
        const cardWidth = c.width - leftMar * 2;
        ctx.drawImage(
          imgs[0],
          0,
          0,
          imgs[0].width,
          imgs[0].height,
          0,
          0,
          c.width,
          c.height
        );
        ctx.drawImage(
          imgs[1],
          0,
          0,
          imgs[1].width,
          imgs[1].height,
          (c.width - cardWidth) / 2,
          400,
          cardWidth,
          750
        );
        const leftText = 100;
        const cardTextWidth = c.width - leftText * 2;
        writeText(
          ctx,
          "这个机器人可以领取好多福利哦，快来看看吧",
          {
            font: "50px",
            align: "center",
            baseline: "top",
            color: "#767676",
          },
          c.width,
          630,
          1130,
          60
        );
        _this.shareImg = c.toDataURL("image/jpeg");
        // console.log('shareImg', _this.shareImg)
        _this.shareImageApp(_this.shareImg);
        // _this.setMaskDataAsync(_this.shareImg);
        _this.setMaskDataAsync(null);
      });
    },

    drawImg() {
      let _this = this;
      if (_this.shareImg) {
        _this.shareImageApp(_this.shareImg);
        return;
      }
      this.setMaskDataAsync({ type: 10, text: "图片生成中，请稍后..." });
      let bg = "http://q4fq3h0km.bkt.clouddn.com/billBg2.png";
      let newsImg = "http://q4fq3h0km.bkt.clouddn.com/newsImg.png";
      let c = document.createElement("canvas");
      let ctx = c.getContext("2d");
      c.width = this.canvasW;
      c.height = this.canvasH;
      _this.shareHbImg(c, ctx, bg, newsImg);
    },
    // html2canva 画页面
    html2canvaDrawImg(times) {
      let _this = this;
      this.setChatLoading(false);
      this.service.pageScrollTo();
      // 清空图片
      let obj = document.getElementById("showimg");
      obj.src = "";
      _this.setShowPicTop(true);
      _this.setMaskDataAsync({ type: 10, text: "图片生成中，请稍后..." });
      drawContentWrapper;
      let htmlDom = document.getElementById("shareImgWrapper");
      let htmlDom2 = document.getElementById("drawContentWrapper");
     
       let computedStyle = getComputedStyle(htmlDom2, null);
       let marginTopnumber=computedStyle.marginTop.split("p")[0]
      // console.log("computedStyle.marginTop", computedStyle.marginTop,marginTopnumber)
      setTimeout(() => {
        let realWidth = htmlDom.clientWidth;
        let realHeight = htmlDom2.clientHeight+parseInt(marginTopnumber) ;
        // console.log("htmlDom444", realWidth, realHeight);
         let imghtml=document.getElementById("sharePageImgJs");
        if(imghtml){
          imghtml.style.height=realHeight+"px"
        }
        html2canvas(htmlDom, {
          width: realWidth, //dom 原始宽度
          height: realHeight,
          scrollY: 0,
          scrollX: 0,
          useCORS: true, // 【重要】开启跨域配置
        }).then((canvas) => {
          let dataURL = canvas.toDataURL("image/png");
          // console.log("canvas", dataURL)
          if (dataURL !== "") {
            _this.shareImg = dataURL;
            _this.setMaskDataAsync(null);
            _this.setShowPicTop(false);
            let obj = document.getElementById("showimg");
            obj.src = dataURL;
            _this.shareImageApp(dataURL);
          }
        });
      }, times);
    },
  },
};
</script>
<style lang="less">
.clear {
  clear: both;
}
.qCardWrapper {
  .itemBox {
    width: 8.25rem;
    color: #313035;
    display: flex;
    /*justify-content: flex-start;*/
    margin: 0.12rem 0.4rem 0.5rem 0.4rem;
  }

  .noMargin {
    margin: 0 !important;
  }

  .content {
    /*padding: 0rem .15rem;*/

    min-width: 2rem;
    border-radius: 0.15rem;

    .textBox {
      width: 100%;
      height: 100%;

      word-break: break-all;
    }
  }

  .marginCls {
    margin-bottom: 0.2rem;
  }

  .borderTop {
    border-top: 1px solid #ff0006;
  }
}
</style>
